"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: ", "px;\n  height: 0;\n  margin-left: ", "px;\n  background-color: rgba(0, 0, 0, 0.2);\n  box-shadow: 0 0 ", "px 1px rgba(0, 0, 0, ", ");\n  border-radius: ", "px ", "px;\n  position: absolute;\n  animation: ", " ", "s linear infinite ", "s;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: ", "px;\n  height: ", "px;\n  background-color: ", ";\n  border-radius: ", "px;\n  /* this border necessary for visibility in high contrast mode */\n  border: 1px solid ", ";\n  position: absolute;\n  animation: ", " ", "s linear infinite, ", " ", "s linear infinite ", "s;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:not(:last-child) {\n    margin-bottom: 20px;\n  }\n\n  > div {\n    position: relative;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  0% {\n    transform: translateX(", "px);\n  }\n  16.666% {\n    transform: translateX(", "px);\n  }\n  33.3333% {\n    transform: translateX(", "px);\n  }\n  50% {\n    transform: translateX(", "px);\n  }\n  66.6666% {\n    transform: translateX(", "px);\n  }\n  83.333% {\n    transform: translateX(", "px);\n  }\n  100% {\n    transform: translateX(", "px);\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  0% {\n    bottom: 0;\n    animation-timing-function: ease-out;\n  }\n  50% {\n    bottom: ", ";\n    animation-timing-function: ease-in;\n  }\n  100% {\n    bottom: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var width = 12;
var height = width;
var color = '#0D9BD5';
var bounceHeight = '40px';
var bounceWidth = 3;
var bounceDuration = 0.6;
var shadowStrength = 0.08;
var bounce = (0, _styledComponents.keyframes)(_templateObject(), bounceHeight);
var move = (0, _styledComponents.keyframes)(_templateObject2(), width * bounceWidth * -1, width * bounceWidth * -0.3333, width * bounceWidth * 0.3333, width * bounceWidth, width * bounceWidth * 0.3333, width * bounceWidth * -0.3333, width * bounceWidth * -1);

var Wrapper = _styledComponents.default.div(_templateObject3());

var Loader = _styledComponents.default.div(_templateObject4(), width, height, color, width + height, color, bounce, bounceDuration, move, bounceDuration * 6, bounceDuration / 2.5);

var LoaderShadow = _styledComponents.default.div(_templateObject5(), width / 2, width / 4, width / 10, shadowStrength, width, height, move, bounceDuration * 6, bounceDuration / 2.5);

var HomePointLogoAnimation = function HomePointLogoAnimation(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Loader, null), /*#__PURE__*/_react.default.createElement(LoaderShadow, null)));
};

HomePointLogoAnimation.propTypes = {
  /** class name string */
  className: _propTypes.default.string
};
HomePointLogoAnimation.defaultProps = {
  className: ''
};
var _default = HomePointLogoAnimation;
exports.default = _default;